import React from "react";
import { useLocation } from "react-router-dom";

export default function AppLayout({ header, children, modal }) {
  const location = useLocation();
  const isFireOn = location.pathname.startsWith("/fire-on");
  const isFireOnAlarmMonitor = location.pathname.startsWith(
    "/fire-on/alarm-monitor"
  );
  const isDbms = location.pathname.startsWith("/dbms");

  return (
    <div id="wrap">
      <div
        className={`boardContainer ${isFireOn ? "darkBoardContainer" : ""} ${isFireOnAlarmMonitor ? "monitorContainer" : ""
          }`}
      >
        {isFireOn === true && (
          <>
            <header id="header" className={`pc ${isDbms ? "black" : ""} `}>
              {header}
            </header>
            <header id="mb_header" className="mb">
              {header}
            </header>
          </>
        )}
        {children}
      </div>
      {modal}
    </div>
  );
}
